module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('sk-panel', [_c('sk-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('h2', [_vm._v("Your Booking")]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm1": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "tertiary": "",
      "small": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.confirmCancelOrder($event)
      }
    }
  }, [_vm._v("Cancel")])], 1)], 1), _vm._v(" "), _c('sk-dialog', {
    attrs: {
      "width": "80%",
      "lazy": "",
      "persistent": "",
      "fullscreen": (_vm.$breakpoints.xs ? true : false),
      "overlay": true
    },
    model: {
      value: (_vm.toggleDialog),
      callback: function($$v) {
        _vm.toggleDialog = $$v
      },
      expression: "toggleDialog"
    }
  }, [(_vm.cancelOrderLoad) ? _c('div', {
    staticClass: "text-center"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "50",
      "width": 2,
      "primary": ""
    }
  })], 1) : [_c('h4', [_vm._v("Are you sure you want to cancel your booking?")]), _vm._v(" "), _c('p', [_vm._v("By clicking cancel you'll lose your seats and might not get them back again.")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleDialog = false
      }
    }
  }, [_vm._v("Wait, take me back")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "loading": _vm.cancelOrderLoad
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.cancelOrder();
        _vm.toggleDialog = false;
      }
    }
  }, [_vm._v("I'm sure\n            ")])]], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "check-ticket"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('sk-progress-circular', {
    attrs: {
      "indeterminate": "",
      "size": "100",
      "width": 2,
      "primary": ""
    }
  })], 1) : _c('div', [_vm._l((_vm.order.Sessions), function(session) {
    return [(session.movie) ? [_c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs5": "",
        "sm3": "",
        "md2": ""
      }
    }, [_c('div', {
      staticClass: "movie-poster"
    }, [_c('img', {
      staticClass: "img-responsive",
      attrs: {
        "src": session.movie.poster
      }
    })])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs7": "",
        "sm9": "",
        "md10": ""
      }
    }, [_c('div', {
      staticClass: "check-ticket--right"
    }, [_c('div', {
      staticClass: "movie-details"
    }, [_c('div', {
      staticClass: "movie-title"
    }, [_c('h4', [_vm._v(_vm._s(session.movie.title))])]), _vm._v(" "), _c('div', {
      staticClass: "movie-info--tags"
    }, [_c('span', [_vm._v(_vm._s(session.movie.rating))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(session.movie.runtime_hour_minute.hours) + "h" + _vm._s(session.movie.runtime_hour_minute.minutes) + "m")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(session.movie.genresString))])]), _vm._v(" "), _c('sk-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('div', {
      staticClass: "movie-info--details"
    }, [_c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Cinema Type")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(session.MovieSession.experiencesString))]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Where")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(session.MovieSession.cinema.name))]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("When")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(_vm.formatVistaDate(session.MovieSession.show_time)))]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Estimated Run Time")]), _vm._v(" "), _c('h5', {
      staticClass: "cart-items__sub-heading"
    }, [_vm._v(_vm._s(_vm.formatVistaTime(session.MovieSession.show_time)) + " -\n                                                                    " + _vm._s((session.MovieSession.show_time.date.clone().add(session.movie.runtime, 'minutes').format('h:mm a'))))])])]), _vm._v(" "), _c('sk-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [(session.Tickets) ? _c('div', {
      staticClass: "cart-items cart--tickets"
    }, [_c('h5', {
      staticClass: "cart-items__heading"
    }, [_vm._v("Your Tickets")]), _vm._v(" "), _c('sk-list', _vm._l((_vm.getTicketsGrouped(session.Tickets)), function(ticketObject, TicketType) {
      return _c('sk-list-item', {
        key: TicketType
      }, [_c('sk-ticket-seats', {
        attrs: {
          "ticket-obj": ticketObject,
          "ticket-type": TicketType,
          "currency": _vm.currency
        }
      })], 1)
    }))], 1) : _vm._e()])], 1)], 1)])])], 1)] : _vm._e()]
  }), _vm._v(" "), (_vm.order.Concessions.length > 0) ? _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('hr')]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs5": "",
      "sm3": "",
      "md2": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs7": "",
      "sm9": "",
      "md10": ""
    }
  }, [_c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "grow": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "cart-items cart--extras"
  }, [_c('h5', {
    staticClass: "cart-items__heading"
  }, [_vm._v("Your Extras")]), _vm._v(" "), _c('sk-list', _vm._l((_vm.groupConcessions(_vm.order.Concessions)), function(concession) {
    return _c('sk-list-item', {
      key: concession.Description
    }, [_c('sk-ticket-seats', {
      attrs: {
        "ticket-obj": concession,
        "ticket-type": concession.Description,
        "currency": _vm.currency
      }
    })], 1)
  }))], 1)])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', [_c('sk-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs9": "",
      "sm9": ""
    }
  }, [_c('sk-layout', [_c('sk-spacer'), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('div', {
    staticClass: "cart-items cart--total"
  }, [_c('span', {
    staticClass: "cart-items__total"
  }, [_vm._v("Total")]), _vm._v(" "), _c('span', {
    staticClass: "cart-items__total-price"
  }, [_vm._v(_vm._s(_vm.total))])])])], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('sk-layout', {
    staticClass: "check-ticket__btns",
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_c('sk-button', {
    attrs: {
      "link": "",
      "router": "",
      "to": "/booking/2"
    }
  }, [_vm._v("Back")]), _vm._v(" "), _c('sk-spacer'), _vm._v(" "), _c('sk-button', {
    attrs: {
      "tertiary": "",
      "router": "",
      "to": "/booking/1"
    }
  }, [_vm._v("Edit Booking")]), _vm._v(" "), _c('sk-button', {
    attrs: {
      "primary": "",
      "router": "",
      "to": ("/booking/4" + (_vm.$route.params.festival_id ? '/film-festival/' + _vm.$route.params.festival_id : ''))
    }
  }, [_vm._v("Checkout")])], 1)], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-80cac134","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/booking/check-ticket/check-ticket.vue
// module id = 729
// module chunks = 0